// extracted by mini-css-extract-plugin
export default {"btn":"HomeBtn_btn__+LWfo","link":"HomeBtn_link__aE5RD"};